import CustomDatatableWithSearch from 'libs/datatables/custom_datatable_with_search'

export default function () {
  $(function() {
    new CustomDatatableWithSearch($('table#installers'), $('#search'), {disableCompactMode: true})
  })
}
